import * as React from "react";
import { useModalContext } from "common/contexts";
import EventProcedureStep from "security-app/components/SecurityEvents/EventProcedures/plugin/EventProcedureStepForm";
import EventProcedureModal from "./EventProcedureModal";
import EventProcedureDetailsDrawer from "./DetailsDrawer";
function EventProceduresModals() {
  const { modal, setModal, entity, setEntity } = useModalContext();
  const onClose = () => {
    setModal(null);
    setEntity(null);
  };
  switch (modal) {
    case "CREATE-EVENT-PROCEDURE":
      return /* @__PURE__ */ React.createElement(EventProcedureModal, { onClose, isCreate: true });
    case "EDIT-EVENT-PROCEDURE":
      return /* @__PURE__ */ React.createElement(EventProcedureModal, { onClose, eventProcedureId: entity });
    case "CREATE-EVENT-PROCEDURE-STEP":
      return /* @__PURE__ */ React.createElement(EventProcedureStep, { onClose });
    case "EDIT-EVENT-PROCEDURE-STEP":
      return /* @__PURE__ */ React.createElement(EventProcedureStep, { eventProcedureStep: entity, onClose });
    case "SHOW-EVENT-PROCEDURE-DETAILS":
      return /* @__PURE__ */ React.createElement(
        EventProcedureDetailsDrawer,
        {
          eventProcedure: entity,
          onClose
        }
      );
    default:
      return null;
  }
}
export default EventProceduresModals;
